interface GradientProps {
  className?: string
}

export const TopGradient = ({ className }: GradientProps) => (
  <div
    className={`h-14 absolute top-0 left-0 w-full pointer-events-none ${className}`}
    style={{
      background: "linear-gradient(180deg, rgba(0, 0, 0, 0.70) 0%, rgba(0, 0, 0, 0.00) 100%)",
    }}
  />
)

export const BottomGradient = ({ className }: GradientProps) => (
  <div
    className={`h-12 absolute bottom-0 left-0 w-full pointer-events-none ${className}`}
    style={{
      background: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.70) 100%)",
    }}
  />
)
